var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuttingEdgeMusicTestingTestIconTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 100,
    viewBox: "0 0 202 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.057 58.8693L104.369 56.8939L99.4288 56.112L99.1159 58.0874L104.057 58.8693Z",
    fill: "#142533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.442 60.038L111.754 58.0626L106.814 57.2807L106.501 59.2561L111.442 60.038Z",
    fill: "#142533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.358 61.1327L118.671 59.1573L113.731 58.3754L113.418 60.3508L118.358 61.1327Z",
    fill: "#142533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.275 62.2274L125.588 60.252L120.648 59.4701L120.335 61.4455L125.275 62.2274Z",
    fill: "#142533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.218 63.3262L132.531 61.3508L127.59 60.5689L127.278 62.5443L132.218 63.3262Z",
    fill: "#142533"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.135 64.4209L139.448 62.4455L134.507 61.6635L134.195 63.6389L139.135 64.4209Z",
    fill: "#142533"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.052 65.5155L146.365 63.5401L141.424 62.7582L141.111 64.7336L146.052 65.5155Z",
    fill: "#142533"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.969 66.6102L153.282 64.6348L148.341 63.8529L148.028 65.8283L152.969 66.6102Z",
    fill: "#142533"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.886 67.7049L160.199 65.7295L155.258 64.9476L154.945 66.923L159.886 67.7049Z",
    fill: "#142533"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.803 68.7996L167.116 66.8242L162.175 66.0423L161.862 68.0177L166.803 68.7996Z",
    fill: "#142533"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.72 69.8942L174.033 67.9188L169.092 67.1369L168.779 69.1123L173.72 69.8942Z",
    fill: "#142533"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.72 69.8942L174.033 67.9188L169.092 67.1369L168.779 69.1123L173.72 69.8942Z",
    fill: "#142533"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.72 69.8942L174.033 67.9188L169.092 67.1369L168.779 69.1123L173.72 69.8942Z",
    fill: "#142533"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.72 69.8942L174.033 67.9188L169.092 67.1369L168.779 69.1123L173.72 69.8942Z",
    fill: "#142533"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M180.637 70.9889L180.95 69.0135L176.009 68.2316L175.696 70.207L180.637 70.9889Z",
    fill: "#142533"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M180.637 70.9889L180.95 69.0135L176.009 68.2316L175.696 70.207L180.637 70.9889Z",
    fill: "#142533"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M180.637 70.9889L180.95 69.0135L176.009 68.2316L175.696 70.207L180.637 70.9889Z",
    fill: "#142533"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M180.637 70.9889L180.95 69.0135L176.009 68.2316L175.696 70.207L180.637 70.9889Z",
    fill: "#142533"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M187.554 72.0836L187.866 70.1082L182.926 69.3263L182.613 71.3017L187.554 72.0836Z",
    fill: "#142533"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M187.554 72.0836L187.866 70.1082L182.926 69.3263L182.613 71.3017L187.554 72.0836Z",
    fill: "#142533"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.554 72.0836L187.866 70.1082L182.926 69.3263L182.613 71.3017L187.554 72.0836Z",
    fill: "#142533"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M187.554 72.0836L187.866 70.1082L182.926 69.3263L182.613 71.3017L187.554 72.0836Z",
    fill: "#142533"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194.471 73.1783L194.783 71.2029L189.843 70.421L189.53 72.3964L194.471 73.1783Z",
    fill: "#142533"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M194.471 73.1783L194.783 71.2029L189.843 70.421L189.53 72.3964L194.471 73.1783Z",
    fill: "#142533"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.471 73.1783L194.783 71.2029L189.843 70.421L189.53 72.3964L194.471 73.1783Z",
    fill: "#142533"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M194.471 73.1783L194.783 71.2029L189.843 70.421L189.53 72.3964L194.471 73.1783Z",
    fill: "#142533"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M201.387 74.2729L201.7 72.2976L196.76 71.5156L196.447 73.491L201.387 74.2729Z",
    fill: "#142533"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M201.387 74.2729L201.7 72.2976L196.76 71.5156L196.447 73.491L201.387 74.2729Z",
    fill: "#142533"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M201.387 74.2729L201.7 72.2976L196.76 71.5156L196.447 73.491L201.387 74.2729Z",
    fill: "#142533"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M201.387 74.2729L201.7 72.2976L196.76 71.5156L196.447 73.491L201.387 74.2729Z",
    fill: "#142533"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M201.387 74.2729L201.7 72.2976L196.76 71.5156L196.447 73.491L201.387 74.2729Z",
    fill: "#142533"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M201.387 74.2729L201.7 72.2976L196.76 71.5156L196.447 73.491L201.387 74.2729Z",
    fill: "#142533"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M201.387 74.2729L201.7 72.2976L196.76 71.5156L196.447 73.491L201.387 74.2729Z",
    fill: "#142533"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M201.387 74.2729L201.7 72.2976L196.76 71.5156L196.447 73.491L201.387 74.2729Z",
    fill: "#142533"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#142533"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 59.6562H69.8125V69.8125H65.75V59.6562Z",
    fill: "#F2F2F2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.625 49.5H61.6875V69.8125H57.625V49.5Z",
    fill: "#F2F2F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3435 69.8125C36.6509 69.8093 34.0694 68.7383 32.1655 66.8343C30.2615 64.9303 29.1904 62.3489 29.1873 59.6563H33.2498C33.2498 60.8615 33.6071 62.0396 34.2767 63.0418C34.9463 64.0439 35.898 64.8249 37.0115 65.2861C38.125 65.7474 39.3503 65.868 40.5323 65.6329C41.7144 65.3978 42.8002 64.8174 43.6524 63.9652C44.5047 63.113 45.085 62.0272 45.3202 60.8451C45.5553 59.663 45.4346 58.4378 44.9734 57.3243C44.5122 56.2108 43.7311 55.2591 42.729 54.5895C41.7269 53.9199 40.5487 53.5625 39.3435 53.5625V49.5C42.0371 49.5 44.6204 50.57 46.5251 52.4747C48.4297 54.3794 49.4998 56.9626 49.4998 59.6563C49.4998 62.3499 48.4297 64.9331 46.5251 66.8378C44.6204 68.7425 42.0371 69.8125 39.3435 69.8125Z",
    fill: "#F2F2F2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8745 21.0625H25.1245C24.0474 21.0636 23.0147 21.4919 22.2531 22.2536C21.4914 23.0152 21.0631 24.0479 21.062 25.125V73.875C21.0632 74.9521 21.4917 75.9847 22.2533 76.7463C23.0149 77.5079 24.0474 77.9363 25.1245 77.9375H73.8745C74.9515 77.936 75.984 77.5076 76.7455 76.746C77.5071 75.9845 77.9356 74.952 77.937 73.875V25.125C77.9358 24.0479 77.5074 23.0153 76.7458 22.2537C75.9842 21.4921 74.9516 21.0637 73.8745 21.0625ZM73.8745 39.3437H45.437V25.125H73.8745V39.3437ZM41.3745 25.125V39.3437H25.1245V25.125H41.3745ZM25.1245 73.875V43.4062H73.8759L73.8786 73.875H25.1245Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuttingEdgeMusicTestingTestIconTail);
export default __webpack_public_path__ + "static/media/CuttingEdgeMusicTestingTestIconTail.59282570a981dc9f1dcab56d4e170121.svg";
export { ForwardRef as ReactComponent };